export default "__VITE_ASSET__Dgp08MDv__"